import { useSearchActions } from '@yext/search-headless-react';
import { executeSearch, executeAutocomplete } from '../utils/search-operations';
import { updateLocationIfNeeded } from '../utils/location-operations';
import { useRef } from 'react';
/**
 * Returns a search action that will handle near me searches, by first checking
 * for near me intents using an autocomplete request.
 *
 * @remarks
 * You can optionally use the provided ref to store autocomplete responses, to avoid
 * making unnecessary autocomplete requests.
 */
export function useSearchWithNearMeHandling(geolocationOptions, onSearch) {
    /**
     * Allow a query search to wait on the response to the autocomplete request right
     * before the search execution in order to retrieve the search intents.
     */
    const autocompletePromiseRef = useRef();
    const searchActions = useSearchActions();
    async function executeQuery() {
        var _a, _b;
        let intents = [];
        if (!searchActions.state.location.userLocation) {
            if (!autocompletePromiseRef.current) {
                autocompletePromiseRef.current = executeAutocomplete(searchActions);
            }
            const autocompleteResponseBeforeSearch = await autocompletePromiseRef.current;
            intents = (autocompleteResponseBeforeSearch === null || autocompleteResponseBeforeSearch === void 0 ? void 0 : autocompleteResponseBeforeSearch.inputIntents) || [];
            await updateLocationIfNeeded(searchActions, intents, geolocationOptions);
        }
        const verticalKey = (_a = searchActions.state.vertical.verticalKey) !== null && _a !== void 0 ? _a : '';
        const query = (_b = searchActions.state.query.input) !== null && _b !== void 0 ? _b : '';
        onSearch
            ? onSearch({ verticalKey, query })
            : executeSearch(searchActions);
    }
    return [executeQuery, autocompletePromiseRef];
}
//# sourceMappingURL=useSearchWithNearMeHandling.js.map